/**
 * Created by Administrator on 2018/6/6.
 */
import Vue from 'vue'
import Vuex from 'vuex'

import loginMsg from './modules/loginMsg'
import loading from './modules/loading'
import currentTitle from './modules/currentTitle'
import userMsg from './modules/userMsg'
import envData from './modules/envData'

Vue.use(Vuex)

export default new Vuex.Store({
  modules:{
    loading,
    loginMsg,
    userMsg,
    currentTitle,
    envData
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js